export class CalculatedPrice {
}
//# sourceMappingURL=calculated-price.js.map